module.exports = __webpack_public_path__ + "static/media/mysql.8464896b.png";